import * as React from "react";
import {KatLink} from "@amzn/katal-react";
import {ElementProps} from "src/app/model/ElementProps";

const HrefElement = (props: ElementProps) => {
    const link = JSON.parse(props.element.jsonVal);
    return (
        <KatLink
            href={link.href}
            label={link.name}
            target={link.target || "_self"}
            data-testid='href-element'></KatLink>
    )
}

export default HrefElement;